import React, { memo } from 'react';

import { Typography } from '@mui/material';
import PropTypes from 'prop-types';

const ErrorContent = ({ contentProps }) => (
  <Typography color="error.main" component="p" variant="regular14">
    {contentProps.errorMessage}
  </Typography>
);

ErrorContent.propTypes = {
  contentProps: PropTypes.shape({
    errorMessage: PropTypes.string.isRequired,
  }).isRequired,
};

export default memo(ErrorContent);
